import { render, staticRenderFns } from "./DriverTermsAndCoditions.vue?vue&type=template&id=369afa76"
import script from "./DriverTermsAndCoditions.vue?vue&type=script&lang=js"
export * from "./DriverTermsAndCoditions.vue?vue&type=script&lang=js"
import style0 from "./DriverTermsAndCoditions.vue?vue&type=style&index=0&id=369afa76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports